// Empty shim for 'ws' package
// Browsers use native WebSocket, so this is never actually called
export default undefined
